import React from 'react';

const WebhooksListing = React.lazy(
  () => import('./webhooks/listing/cowbell/WebhooksListing')
);
const WebhookDetails = React.lazy(() => import('./webhooks/WebhookDetails'));
// Exported because Pool builds its own route list from the same pages: its
// api-keys paths, permissions and nav entries all differ, so it cannot share
// the list below, but the pages themselves are the same three.
export const ApiKeys = React.lazy(() => import('../../admin/apiKeys/ApiKeys'));
export const ApiKeyCreation = React.lazy(
  () => import('../../admin/apiKeys/ApiKeyCreation')
);
export const ApiActivityTracking = React.lazy(
  () => import('../../apiKeys/ApiActivityTracking')
);

/**
 * The Developers tab set, which every persona but Pool mounts identically —
 * only the URL prefix differs. Each persona's `*.developers.routes` file held
 * its own byte-identical copy of this list, so a label change had to be made
 * nine times to stay consistent.
 *
 * `rootPath` is the persona's Developers root, e.g. `/agency/developers`.
 */
export const useDeveloperRoutes = (rootPath: string) => {
  return React.useMemo(
    () => [
      {
        path: `${rootPath}/webhooks/:id`,
        allow: 'any',
        component: WebhookDetails,
      },
      {
        path: `${rootPath}/api-keys/create`,
        allow: { api_keys: 'manage' },
        component: ApiKeyCreation,
      },
      {
        path: `${rootPath}/api-keys/activity`,
        allow: 'any',
        component: ApiActivityTracking,
        rqps: ['size', 'dateFilter', 'before', 'after', 'orderBy', 'order'],
      },
      {
        path: `${rootPath}/api-keys`,
        allow: { api_keys: 'view' },
        component: ApiKeys,
        rqps: ['size', 'order', 'orderBy'],
        nav: {
          name: 'Api Keys',
        },
      },
      {
        path: `${rootPath}/webhooks`,
        allow: 'any',
        component: WebhooksListing,
        nav: {
          name: 'Outgoing Webhooks',
        },
      },
    ],
    [rootPath]
  );
};
